export { Badge } from './Badge';
export type { BadgeVariant } from './Badge';
